import AuthCallbackForm from "../../components/Compound/AuthCallbackForm";


const AuthCallback = () => {
  return <AuthCallbackForm />
};

export default AuthCallback;